import '../App.css';
import '../Css/Footer.css';


export default function Banner() {


  return (
    <div id='footerContainer'>
        <div id='footerLogo'>
            <img id='footerLogoImg'src='./images/logo/Logo Astraya Violet Texte.png'></img>
            <div id='copyright'>© 2026 Astraya SNC</div>
        </div>
        <div id='footerHoraires'>
            <p className='footerTitle'>Horaires</p>
            <p className='footerText'>Du lundi au Samedi : <br></br> de 8:00 à 18:00</p> 
        </div>
        <div id='footerLinks'>
            <p className='footerTitle'>Liens utiles</p>
            <div id='links'>
                <a href='mailto: contact@astraya.ch'><img className='footerLink' src='./images/icons/envelope-icon-purple.png'></img></a>
                <a href='https://www.linkedin.com/company/astraya-technologies'><img className='footerLink' src='./images/icons/linkedin-square-icon-purple.png'></img></a>
            </div>
        </div>
    </div>
  );
}